module.exports = __webpack_public_path__ + "static/img/ren_wu_zong_shu.dd303ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/ren_wu_zong_shu.png
// module id = 58Ie
// module chunks = 2